import { Vec3 } from 'vec3';
import { CustomWorld } from './world';
export declare const server: (serv: Server, options: Options) => void;
export declare const player: (player: Player, serv: Server, options: Options) => void;
export declare const entity: (entity: Entity, serv: Server) => void;
declare global {
    interface Server {
    }
    interface Player {
    }
    interface Entity {
        /** Only applies to gravity, really. You can still apply a velocity larger than terminal velocity. */
        terminalvelocity: Vec3;
        /** If a block drop, what item id */
        itemId?: number;
        /** If a block drop, what item damage */
        itemDamage?: number;
        /** World object entity is in */
        world: CustomWorld;
        /** Numerical type of the entity. */
        entityType: number;
        /** List of entities that the entity believes is nearby. */
        nearbyEntities: Entity[];
        /** How far away entities are loaded/unloaded (used for players ATM) */
        viewDistance: number;
        /** When an entity was born. Used with pickupTime and deathTime (time in epoch) */
        bornTime: number;
        /** Metadata for the entity (not like block metadata/damage). Contains stuff like NBT. */
        metadata: any;
        /** Pitch of entity's head */
        headPitch: number;
    }
}
